exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-4c92e630]{background-color:#fff}.page[data-v-4c92e630],.page .map[data-v-4c92e630]{width:100%;height:100vh}", ""]);

// exports
